import Button from '@components/Button';
import { Collapse } from '@components/Collapse';
import FeatureToggle from '@components/FeatureToggle';
import Textarea from '@components/Textarea';
import { Validator } from '@components/Validator';
import useTextareaHandelrs from '@hooks/useTextareaHandelrs';
import { $editingMapMarkerApi } from '@stores/editingMarkerStores';
import { $playerWidgetsApi } from '@stores/playerWidgets';
import {
  type STMapMarker,
  type STMapMarkerText,
  STMapMarkerType,
} from '@types';
import type { Draft } from 'immer';
import { flagToBool, toFlag } from 'pano-utils';
import { useEffect } from 'react';
import { stEditorAmap } from '../STAMap';

interface Props {
  marker: STMapMarkerText;
}

export function FeatureSettingsText({ marker }: Props) {
  const updateMarkerObject = (markerData: STMapMarkerText) => {
    const markerObject = stEditorAmap.getMarkerObjectById(
      marker.id
    ) as AMap.Text | null;
    if (!markerObject) return;
    markerObject.setStyle(
      stEditorAmap.generateTextStyle(markerData, {
        isSelected: true,
      })
    );
    markerObject.setExtData({
      ...markerObject.getExtData(),
      markerData,
    });
    markerObject.setText(markerData.title || '请输入标记文本');
  };

  useEffect(() => {
    updateMarkerObject(marker);
  }, [marker]);

  const updateMarker = (
    updater: (draft: Draft<STMapMarkerText>) => STMapMarker | void
  ) => {
    $editingMapMarkerApi.update((draft) => {
      draft.type ??= STMapMarkerType.text;
      if (draft.type !== STMapMarkerType.text) return;
      updater(draft);
    });
  };

  const handlers = useTextareaHandelrs('trimRight', (val) => {
    updateMarker((draft) => {
      draft.title = val;
    });
  });

  return (
    <Collapse title="标记文本">
      <Validator
        value={marker.title}
        validFn={() => !!marker.title.trim()}
        warningMessage="请输入标记文本"
      >
        {({ value, warning }) => (
          <Textarea
            scheme="dark"
            className="mb-20 h-115"
            placeholder="请输入标记文本"
            maxLength={500}
            value={value}
            warning={warning}
            {...handlers}
          />
        )}
      </Validator>
      <FeatureToggle
        title="跟随画面同步缩放"
        className="mb-20"
        isOn={flagToBool(marker.icon.stick)}
        onToggle={(isOn) => {
          updateMarker((draft) => {
            draft.icon.stick = toFlag(isOn);
          });
        }}
      />
      <Button
        className="mt-20 w-full"
        onClick={() => $playerWidgetsApi.add('title')}
      >
        文本高级设置
      </Button>
    </Collapse>
  );
}
